// extracted by mini-css-extract-plugin
export default {"description":"DamageNotificationModal_description__biTpo","companyName":"DamageNotificationModal_companyName__1uR3M","time":"DamageNotificationModal_time__MroDP"};